import { Button } from '@/components/ui/button';

// ============================================================================
// AuditHistoryPanel — панель истории изменений записи (аудит, как в 1С):
// «Последнее изменение» + кнопка «История» (раскрывает записи: операция/кто/
// когда/было/стало). Вынесена из AutoObjectForm (снижение цикломатики).
// ============================================================================

export interface AuditRecordView {
  id: string;
  operation: string;
  performedBy?: string;
  performedAt?: string;
  oldData?: string;
  newData?: string;
}

interface AuditHistoryPanelProps {
  lastRecord?: AuditRecordView | null;
  records: AuditRecordView[];
  loading: boolean;
  error?: string | null;
  open: boolean;
  onToggle: () => void;
}

export function AuditHistoryPanel({ lastRecord, records, loading, error, open, onToggle }: AuditHistoryPanelProps) {
  return (
    <div className="rounded-md border bg-muted/30 px-3 py-2">
      <div className="flex items-center justify-between gap-2">
        {lastRecord ? (
          <div className="text-xs text-muted-foreground">
            <span className="font-medium text-foreground">Последнее изменение:</span>{' '}
            {lastRecord.performedBy || '—'} • {lastRecord.performedAt ? new Date(lastRecord.performedAt).toLocaleString() : ''} • {lastRecord.operation}
          </div>
        ) : (
          <div className="text-xs text-muted-foreground">История изменений отсутствует</div>
        )}
        <Button size="sm" variant="ghost" onClick={onToggle} disabled={loading}>
          {open ? 'Скрыть' : 'История'}
        </Button>
      </div>
      {open && (
        <div className="mt-2 space-y-2 border-t pt-2">
          {loading && <div className="text-xs text-muted-foreground">Загрузка…</div>}
          {error && <div className="text-xs text-destructive">{error}</div>}
          {records.length === 0 && !loading && <div className="text-xs text-muted-foreground">Нет записей</div>}
          {records.map((r) => (
            <div key={r.id} className="text-xs space-y-1">
              <div className="flex items-center gap-2">
                <span className="font-medium">{r.operation}</span>
                <span className="text-muted-foreground">{r.performedBy || '—'}</span>
                <span className="text-muted-foreground">{r.performedAt ? new Date(r.performedAt).toLocaleString() : ''}</span>
              </div>
              {r.oldData && r.oldData !== '{}' && (
                <div className="text-muted-foreground truncate" title={r.oldData}>Было: {r.oldData}</div>
              )}
              {r.newData && r.newData !== '{}' && (
                <div className="text-muted-foreground truncate" title={r.newData}>Стало: {r.newData}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
